
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Our firebase config
const firebaseConfig = {
  apiKey: "AIzaSyAh_X1GY2WquDR2Pv9VxmuEzhtQdiH2b6E",
  authDomain: "placeholder-concept-trust.firebaseapp.com",
  databaseURL: "https://placeholder-concept-trust-default-rtdb.firebaseio.com",
  projectId: "placeholder-concept-trust",
  storageBucket: "placeholder-concept-trust.appspot.com",
  messagingSenderId: "709663614681",
  appId: "1:709663614681:web:9e1e117dee1be3ce66c0c8"
};

// Initialize Firebase
/* eslint-disable no-unused-vars */
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

const db = getFirestore();
const storage = getStorage(app);


export { db, storage };
// export default db;
